var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "articlecontainer" }, [
    _c(
      "div",
      {
        staticClass:
          "flex flex-col lg:w-2/3 items-stretch gap-md mb-lg lg:pr-xs",
      },
      [
        _c("div", [
          _c(
            "label",
            {
              staticClass: "font-semibold mb-xxs inline-block",
              attrs: { for: "search" },
            },
            [_vm._v("Zoeken")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "relative" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.params.search,
                  expression: "params.search",
                },
              ],
              staticClass:
                "form__input py-[20px] pr-lg px-sm form__input--filled-dark placeholder:text-ellipsis",
              attrs: {
                id: "search",
                name: "search",
                placeholder: "Vul hier een trefwoord in",
                type: "text",
              },
              domProps: { value: _vm.params.search },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.params, "search", $event.target.value)
                  },
                  _vm.searchImmediately,
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "absolute right-sm top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-400 cursor-pointer",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.search.apply(null, arguments)
                  },
                },
              },
              [_c("i", { staticClass: "fa-regular fa-search" })]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-wrap gap-sm items-center justify-start" },
          [
            _vm._l(_vm.categories, function (item) {
              return [
                item.count > 0 &&
                item.slug !== "geen-onderdeel-van-een-categorie"
                  ? _c("a", {
                      key: item.id,
                      staticClass:
                        "py-xxs px-xs text-xs uppercase hover:text-primary-400 hover:border-primary-400 text-gray-500 border transition-colors inline-flex border-gray-600 text-opacity-80 tracking-[2px] font-semibold cursor-pointer select-none",
                      class: {
                        "bg-primary-400 !text-gray-800":
                          _vm.active_categories.includes(item.id),
                      },
                      attrs: { href: "#" },
                      domProps: { innerHTML: _vm._s(item.name) },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.filter(item.id)
                        },
                      },
                    })
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { key: "loading", staticClass: "flex justify-center" }, [
          _vm._m(0),
        ])
      : _vm.articles.length
      ? _c(
          "div",
          { staticClass: "grid grid-cols-12 gap-y-lg sm:gap-x-md md:gap-y-xl" },
          [
            _vm._l(_vm.articles, function (item, index) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "col-span-12 xs:col-span-6 md:col-span-4 flex",
                },
                [_c("blogitem", { attrs: { content: item } })],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-span-12" },
              [
                _c("pagination", {
                  attrs: {
                    "current-page": _vm.params.page,
                    "total-pages": _vm.totalPages,
                  },
                  on: {
                    "next-page": function ($event) {
                      return _vm.filter(null, _vm.params.page + 1)
                    },
                    "previous-page": function ($event) {
                      return _vm.filter(null, _vm.params.page - 1)
                    },
                    "go-to-page": function (event) {
                      return _vm.filter(null, event.page)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          2
        )
      : _c("div", { key: "empty" }, [
          _c("p", { staticClass: "my-3xl text-center" }, [
            _vm._v("Geen artikels gevonden. Probeer een andere zoekopdracht."),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center",
      },
      [
        _c("i", {
          staticClass:
            "fa-regular fa-spinner-third h-[60px] w-auto animate-spin",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }